import moment from "moment";

export default (format) => {
  return moment(
    new Date(+new Date() - Math.floor(Math.random() * 10000000000))
  ).format(format);
};
